import { render, staticRenderFns } from "./EntityIdentityCreate.vue?vue&type=template&id=72f5d390"
import script from "./EntityIdentityCreate.vue?vue&type=script&lang=js"
export * from "./EntityIdentityCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports